import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import NavBar from "../components/navbar/NavBar";
import { useState } from "react";
import CreateDashboard from "../components/manage-dashboard/CreateDashboard";
import UpdateDashboard from "../components/manage-dashboard/UpdateDashboard";

const ManageDashboard: React.FC = () => {
  const [action, setAction] = useState("create");
  const [formType, setFormType] = useState("")
  const handleNextButton = () => {
    if (action === "create") {
        setFormType("create-dashboard")
    } else if (action === "edit") {
        setFormType("edit-dashboard")
    }
  }
  const handleCancel = () => {
    setFormType("")
  }
  return (
    <Box sx={{ minHeight: "100vh", height: "100vh" }}>
      <NavBar />
      {!formType && <Box
        sx={{
          display: "flex",
          backgroundColor: "#181818",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          minHeight: "100vh"
        }}
      >
        <Paper
          sx={{
            padding: 4,
            color: "#ffffff",
            backgroundColor: "#1e1e1e",
            borderRadius: 2,
            maxWidth: 400,
            width: "100%",
          }}
          elevation={4}
        >

          {/* Radio Button Group */}
          <FormControl component="fieldset" sx={{ marginTop: 2, width: "100%" }}>
            <Typography variant="subtitle1" sx={{ color: "#ffffff" }}>
              Choose your action
            </Typography>
            <RadioGroup aria-label="action" name="radio-buttons-group"  onChange={(event, value) => {
                setAction(value)
              }}
              value={
                action
              }>
              <FormControlLabel
                value="create"
                control={<Radio sx={{ color: "#ffffff" }} />}
                label="Create"
                sx={{ color: "#ffffff" }}
              />
              <FormControlLabel
                value="edit"
                control={<Radio sx={{ color: "#ffffff" }} />}
                label="Edit"
                sx={{ color: "#ffffff" }}
              />
            </RadioGroup>
          </FormControl>
          <Button variant="contained"
            onClick={handleNextButton}
            style={{
                marginTop: "3vh",
              backgroundColor: "#8F201B",
              color: "#FFFFFF",
              borderRadius: "100px",
              textTransform: "none",
            }}>Next</Button>
        </Paper>
      </Box>}
      {formType === "create-dashboard" && <CreateDashboard handleCancel={handleCancel}/>}
      {formType === "edit-dashboard" && <UpdateDashboard handleCancel={handleCancel}/>}
    </Box>
  );
};

export default ManageDashboard;
